import styled from 'styled-components';

export const BadgesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  justify-content: space-around;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
  }
`;
